// extracted by mini-css-extract-plugin
export default {"container":"dcc_check-container","check":"dcc_check-check","cancel":"dcc_check-cancel","table":"dcc_check-table","td":"dcc_check-td"};